<template>

  <div class="big">
    <el-dialog title="添加/编辑图片"
               :visible.sync="dialogdata"
               width="620px"
               style="text-align: left"
               :close-on-click-modal="false"
               @close="close"
               @open="opendialog">
      <div class="imgUpContainer">
        <!--图片列表-->
        <div class="imgShowList">
          <transition-group class="drag-sort-box"
                            name="sort"
                            tag="div"
                            @dragover="dragover($event)">
            <div v-for="(item,index) in imageInfo.imageList"
                 :key="index"
                 :class="[itemClass, 'drag-sort-item','imgItem']"
                 :style="{'width':`${packingWidth}px`,'height':`${packingWidth}px`}"
                 :draggable="true"
                 @dragstart="dragstart(item, index)"
                 @dragenter="dragenter(item, $event)"
                 @dragend="dragend(item, $event)"
                 @dragover="dragover($event)">
              <div>
                <i class="el-icon-close rightDel"
                   @click="deleteImage(index)"></i>
              </div>
              <p class="moxsind">{{ index + 1 }}</p>
              <img :class="index == dargIndex ? 'active imgStyle' : 'imgStyle'"
                   :style="{'width':`${packingWidth}px`,'height':`${packingWidth}px`}"
                   :src="item" />
            </div>
            <!--图片上传-->
            <template v-if="imageInfo.imageList.length <imgNum">
              <div class="packingImageContainer"
                   :style="{'width':`${packingWidth}px`,'height':`${packingWidth}px`}"
                   key="0202">
                <i class="el-icon-plus packingIconStyle"></i>
                <input ref="refSettingFile"
                       type="file"
                       class="inputStyle"
                       :style="{'width':`${packingWidth}px`,'height':`${packingWidth}px`}"
                       accept=".jpg, .png"
                       multiple
                       @change="fileOnChange" />
              </div>
            </template>
          </transition-group>
        </div>
      </div>
      <div style="text-align: right; padding: 0 20px 20px 0; box-sizing: border-box">
        <el-button type="primary"
                   @click="submit"
                   style="width: 92px"
                   size="medium">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/api/common';
import _ from 'lodash';
let oldData = null;
let newData = null;
export default {
  props: {
    isFlag: {
      type: Boolean,
      require: true
    },
    sortType: {
      // 排序方式 insert exchange
      type: String,
      default: 'insert'
    },
    itemClass: {
      type: String,
      default: ''
    }, //自定义类名
    imgNum: {
      type: Number,
      default: 999
    },
    imgList: {
      type: Array,
      default() {
        return [];
      }
    },
    packingWidth: {
      type: [Number, String],
      default: 100
    },
    type: {
      // 页面多用时 标记
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogdata: false,
      imageInfo: {
        img_type: 5,
        suffix: '.jpg',
        imageList: [],
        picList: []
      },
      dargIndex: -1
    };
  },
  watch: {
    imgList: {
      handler: function(val, oldVal) {
        this.imageInfo.imageList = val.map((item) => item.path);
        this.imageInfo.picList = val.map((item) => item.pic);
      },
      deep: true,
      immediate: true
    },
    isFlag() {
      this.dialogdata = true;
    }
  },
  created() {
    this.imageInfo.imageList = this.imageInfo.imageList.map(
      (v, i) => (v = v + '?index=' + i)
    ); //不重复key
  },
  methods: {
    fileOnChange(e) {
      let length = this.imageInfo.imageList.length;
      if (length >= this.imgNum) {
        this.$message.error(`图片上传数不能大于${this.imgNum}张`);
        return;
      }
      let fileObj = this.$refs['refSettingFile'].files;
      const fileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const file = Object.values(fileObj)[0];
      this.imageInfo.suffix = file.name.substring(file.name.lastIndexOf('.'));
      new Promise((resolve, reject) => {
        if (!fileTypes.includes(file.type)) {
          this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
          reject();
          return false;
        }
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小请勿超过5M');
          reject();
          return false;
        }

        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }).then((file) => {
        let data = new FormData();
        data.append('image', file, file.name);
        data.append('img_type', this.imageInfo.img_type);
        data.append('suffix', this.imageInfo.suffix);
        e.target.value = '';
        return this.fileUploadSave(data);
      });
    },
    fileUploadSave(params) {
      const loading = this.$loading();
      common
        .uploadFile(params)
        .then((res) => {
          let { path, pic } = res.data;
          this.imageInfo.imageList.push(path);
          this.imageInfo.picList.push(pic);
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    deleteImage(index) {
      this.imageInfo.imageList.splice(index, 1);
      this.imageInfo.picList.splice(index, 1);
    },
    /* 拖拽相关 */
    dragstart(value, index) {
      oldData = value;
      this.dargIndex = index;
    },
    dragenter(value, e) {
      newData = value;
      e.preventDefault();
    },
    dragover(e) {
      e.preventDefault();
    },
    dragend() {
      if (oldData !== newData) {
        let oldIndex = this.imageInfo.imageList.indexOf(oldData);
        let newIndex = this.imageInfo.imageList.indexOf(newData);
        if (this.sortType == 'insert') {
          let newItems = [...this.imageInfo.imageList];
          newItems.splice(oldIndex, 1);
          newItems.splice(newIndex, 0, oldData);
          this.imageInfo.imageList = [...newItems];

          let newPicItem = [...this.imageInfo.picList];
          newPicItem.splice(oldIndex, 1);
          newPicItem.splice(newIndex, 0, this.imageInfo.picList[oldIndex]);
          this.imageInfo.picList = [...newPicItem];
        } else {
          [
            this.imageInfo.imageList[oldIndex],
            this.imageInfo.imageList[newIndex]
          ] = [
            this.imageInfo.imageList[newIndex],
            this.imageInfo.imageList[oldIndex]
          ];
          [this.imageInfo.picList[oldIndex], this.imageInfo.picList[newIndex]] =
            [
              this.imageInfo.picList[newIndex],
              this.imageInfo.picList[oldIndex]
            ];
        }
        this.dargIndex = -1;
      }
    },
    opendialog() {},
    close() {
      this.dialogdata = false;
    },
    submit() {
      if (this.imgNum === 1) {
        this.type
          ? this.$emit('emitOnly', {
              picList: this.imageInfo.picList,
              type: this.type
            })
          : this.$emit('emitOnly', this.imageInfo.picList);
      } else {
        this.type
          ? this.$emit('emitMore', {
              picList: this.imageInfo.picList,
              type: this.type
            })
          : this.$emit('emitMore', this.imageInfo);
      }
      this.dialogdata = false;
    }
  }
};
</script>

<style scoped lang="scss">
$borderRadius: 6px;
.imgUpContainer {
  padding: 4px;
  .imgShowList {
    .imgItem {
      margin-right: 6px;
      position: relative;
      .imgStyle {
        border-radius: $borderRadius;
      }
      .rightDel {
        background-color: #eee;
        border-radius: 14px;
        position: absolute;
        font-size: 16px;
        top: 1px;
        right: 1px;
        cursor: pointer;
        z-index: 100;
      }
      .rightDel:hover {
        background-color: #999;
      }
    }
  }
  //图片上传
  .packingImageContainer {
    position: relative;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: $borderRadius;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .packingIconStyle {
      font-size: 30px;
    }
    .inputStyle {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }
  .drag-sort-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .drag-sort-item {
      border-radius: $borderRadius;
      margin: 2px;
      cursor: pointer;
      transition: all 0.3s;
      background: #ccc;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.3s;
        position: relative;
      }
      .active {
        border-radius: 30px;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
        opacity: 0;
      }
    }
  }
  .moxsind {
    width: 100%;
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #dfd6d6;
    text-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
    font-size: 50px;
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>